import React,{useEffect, useState} from 'react'
import { useParams } from 'react-router-dom'
import { useTranslation } from "react-i18next"
import { Container, Button, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { getCropDetail, editCrop, getCrops } from '../../../actions/cropsActions'
import FormCrop from '../../admin/crops/FormCrop'
import Swal from 'sweetalert2'

export default function CropEdit() {     
    const { t } = useTranslation()
    const {id} = useParams()
    const {crop} = useSelector(state=>state.crops)   
    const dispatch = useDispatch()

    const [formState, setFormState] = useState({})
    const {name, description, idCrop} = formState

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleEdit = async(e) => {
        e.preventDefault()

        dispatch(editCrop(name, description, idCrop))
        Swal.fire({
            showConfirmButton: true,
            icon: 'success',
            text: t('crops.messageedit')
        })
    }


    useEffect(()=>{
        dispatch(getCropDetail(id))
        dispatch(getCrops())
    }, [dispatch,id])

    useEffect(() => {
        if (crop) {
            setFormState({
                name: crop.name,
                description: crop.description,
                idCrop: crop._id
            })
        }
    }, [crop, dispatch, id])
  
    return (
        <Container className='cuerpo'>
            <Row className="text-left custom-card-header-list">
                <Row className="custom-card-buttom">
                    <Button className="btn btn-secondary mb-4 mx-auto" href={`/admin/crops`}>
                        <i className="fas fa-arrow-circle-left"></i> {t('crops.volver')}
                    </Button>
                </Row>
                <h1>{t('crops.name')}: <span className='text-uppercase'>{crop?.name}</span></h1>
                <FormCrop submit={handleEdit} isNew={false} inputChange={handleInputChange} state={formState}></FormCrop>
            </Row>
        </Container>
    )
}
